import { createI18n } from "vue-i18n";

import messages from "./vue-i18n-locales.generated";

export function createSalesByteI18n(
    locale = document.documentElement.lang.substr(0, 2)
) {
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: "sv",
        messages,
    });
}
